import {
  DATA_FRAME_SOURCE_EXCLUDE_MAP,
  DATA_FRAME_TABLE_ENTRY_SORT_MAP,
  GAME_SOURCE_EXCLUDE_MAP,
  GAME_TABLE_ENTRY_SORT_MAP,
} from './constants';

/** 获取 Source 筛选器需排除的 value 列表，dataFrame 优先于 gameCode */
export const getSourceExcludeList = (
  dataFrame?: string,
  gameCode?: string,
): string[] => {
  if (dataFrame && DATA_FRAME_SOURCE_EXCLUDE_MAP[dataFrame]) {
    return DATA_FRAME_SOURCE_EXCLUDE_MAP[dataFrame];
  }
  if (gameCode && GAME_SOURCE_EXCLUDE_MAP[gameCode]) {
    return GAME_SOURCE_EXCLUDE_MAP[gameCode];
  }
  return [];
};

/** 宽表进入页默认排序配置（sortedBy 为接口 sorted_by 字段，支持任意指标 key） */
export interface ITableEntrySortConfig {
  sortedBy: string;
  desc?: boolean;
}

const DEFAULT_TABLE_ENTRY_SORT: ITableEntrySortConfig = { sortedBy: 'date', desc: true };

/** 获取进入页默认排序配置，dataFrame 优先于 gameCode */
export const getTableEntrySortConfig = (
  dataFrame?: string,
  gameCode?: string,
): ITableEntrySortConfig => {
  if (dataFrame && DATA_FRAME_TABLE_ENTRY_SORT_MAP[dataFrame]) {
    return DATA_FRAME_TABLE_ENTRY_SORT_MAP[dataFrame];
  }
  if (gameCode && GAME_TABLE_ENTRY_SORT_MAP[gameCode]) {
    return GAME_TABLE_ENTRY_SORT_MAP[gameCode];
  }
  return DEFAULT_TABLE_ENTRY_SORT;
};

/** 获取进入页默认排序请求参数 */
export const getTableDefaultSortParams = (
  dataFrame?: string,
  gameCode?: string,
): { sorted_by: string; desc: boolean; } => {
  const config = getTableEntrySortConfig(dataFrame, gameCode);
  return { sorted_by: config.sortedBy, desc: config.desc !== false };
};

/**
 * 获取进入页默认排序 UI 状态
 * sortedBy 为 date 时返回空数组，表头不展示排序态
 * 指标列 key 格式：{sortedBy}{showType}，如 dauvalue_only
 */
export const getTableDefaultSort = (
  dataFrame?: string,
  gameCode?: string,
  showType = 'value_only',
): { by: string; order: 'asc' | 'desc'; }[] => {
  const config = getTableEntrySortConfig(dataFrame, gameCode);
  if (config.sortedBy === 'date') {
    return [];
  }
  return [{
    by: `${config.sortedBy}${showType}`,
    order: config.desc !== false ? 'desc' : 'asc',
  }];
};
